import { render, staticRenderFns } from "./students-messages.vue?vue&type=template&id=512af40c&"
import script from "./students-messages.vue?vue&type=script&lang=js&"
export * from "./students-messages.vue?vue&type=script&lang=js&"
import style0 from "./students-messages.vue?vue&type=style&index=0&id=512af40c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports